var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"pdf"}},[_c('v-btn',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"primary"},on:{"click":function($event){_vm.loading = true,_vm.pdfgen()}}},[_vm._v("Download PDF")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }